module.exports = __webpack_public_path__ + "static/media/instagram.751a308e.png";